import React from 'react';
import styled from 'styled-components';
import GreenhouseLogo from 'self_schedule/candidate_view/shared/greenhouse_logo';
import { SecondaryButtonLink } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('developers_greenhouse_root');

const NavBarWrapper = styled.nav`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  background: white;
  box-shadow: 0 2px 8px rgba(21, 55, 44, 0.1);
  padding: 16px 24px;
`;

const NavContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

type Props = {
  signInPath: string;
};

const NavBar = ({ signInPath }: Props) => (
  <NavBarWrapper>
    <NavContent>
      <GreenhouseLogo />
      <SecondaryButtonLink href={signInPath}>
        {t('sign_in')}
      </SecondaryButtonLink>
    </NavContent>
  </NavBarWrapper>
);

export default NavBar;
